import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Typography,
  Button,
} from "@mui/material";
import http from "@shared/api/http";
import { Grid } from "@mui/material";
import FilePreview from "./FilePreview";

const MaterialsCard = ({ material }: { material: any }) => {
  const handleOpenAttachment = async () => {
    window.open(material.presigned_url, "_blank");
  };

  return (
    <Card
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: "16px",
        border: "1px solid var(--main-color)",
      }}
    >
      <CardHeader
        title={material.title}
        titleTypographyProps={{ variant: "h6" }}
      />
      <CardContent
        sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
      >
        <div
          style={{
            height: "200px",
            marginBottom: "16px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FilePreview
            fileUrl={material?.presigned_url}
            file={material?.location}
          />
        </div>
        <Typography variant="body2">{material.description}</Typography>
      </CardContent>
      <CardActions>
        <Button
          variant="contained"
          onClick={handleOpenAttachment}
          sx={{
            backgroundColor: "var(--main-color)",
            "&:hover": { backgroundColor: "var(--main-color)" },
          }}
        >
          Download
        </Button>
      </CardActions>
    </Card>
  );
};

const Materials = () => {
  const [materials, setMaterials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchMaterials = async () => {
      try {
        const response = await http.get("/de/v2/:token/materials");
        setMaterials(response.data || []);
      } catch (error) {
        console.error("Error fetching materials:", error);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchMaterials();
  }, []);

  if (loading) {
    return <Typography sx={{ padding: "24px" }}>Loading...</Typography>;
  }

  if (error) {
    return (
      <Typography sx={{ padding: "24px" }}>
        Materialien konnten nicht geladen werden. Bitte aktualisiere die Seite.
      </Typography>
    );
  }

  if (materials.length === 0) {
    return (
      <Typography sx={{ padding: "24px" }}>
        Es wurden noch keine Materialien mit Ihnen geteilt.
      </Typography>
    );
  }

  return (
    <Grid
      container
      spacing={3}
      sx={{
        padding: "24px",
        paddingBottom: { xs: "90px", sm: "24px" },
      }}
    >
      {materials.map((material, index) => (
        <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={index}>
          <MaterialsCard material={material} />
        </Grid>
      ))}
    </Grid>
  );
};

export default Materials;
